import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ApplicationFilter.scss";
import {
  getCountryCode,
  getFlagUrl,
} from "../../ContentPages/SysGuardColumnConfig";
import { renderRiskFilterClassName } from "../../../SysGuardCommonComp";

export default function ApplicationFilter({
  onApply,
  onCancel,
  onClear,
  filterField,
  customFilterConfigMap = {},
  customList,
  customSelected,
  customActionType,
}) {

  const config = customFilterConfigMap[filterField] || {};
  const dispatch = useDispatch();

  const reduxList = useSelector((state) =>
    config.listSelector ? config.listSelector(state) : []
  );
  const reduxSelected = useSelector((state) =>
    config.selectedSelector ? config.selectedSelector(state) : []
  );

  const list = customList || reduxList || [];
  const selectedItems = customSelected || reduxSelected || [];

  const [searchTerm, setSearchTerm] = useState("");
  const [tempSelectedItems, setTempSelectedItems] = useState([]);

  useEffect(() => {
    setTempSelectedItems(selectedItems);
  }, [filterField]);

  const filteredList = list.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleSelectAll = () => {
    const allSelected = filteredList.every((item) =>
      tempSelectedItems.includes(item)
    );
    setTempSelectedItems((prev) =>
      allSelected
        ? prev.filter((item) => !filteredList.includes(item))
        : [...new Set([...prev, ...filteredList])]
    );
  };

  const toggleItem = (item) => {
    setTempSelectedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleApply = () => {
    dispatch({ type: config.actionType, payload: [...tempSelectedItems] });
    onApply([...tempSelectedItems]);
  };

  const handleCancel = () => {
    setTempSelectedItems([...selectedItems]);
    setSearchTerm("");
    onCancel();
  };


  const areAllVisibleSelected =
    filteredList.length > 0 &&
    filteredList.every((item) => tempSelectedItems?.includes(item));

  return (
    <div className="application-list-container">
      <div className="application-list-scrollable">
        <div className="application-search">
          <input
            type="text"
            placeholder="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="select-all">
          <label>
            <input
              type="checkbox"
              checked={areAllVisibleSelected}
              onChange={toggleSelectAll}
            />
            Select All
          </label>
        </div>

        {filteredList.map((item) => {
          const code = config.isCountry ? getCountryCode(item) : null;
          const flagUrl = code ? getFlagUrl(code) : null;

          return (
            <div key={item} className="application-item">
              <label className="countryWithFlagContainer">
                <input
                  type="checkbox"
                  checked={tempSelectedItems.includes(item)}
                  onChange={() => toggleItem(item)}
                />
                <div className="flagWithNameContainer">
                  {config.isCountry && (
                    <img
                      src={
                        item !== "Unknown"
                          ? flagUrl || "/sysGuardIcons/unknownFlag.svg"
                          : "/sysGuardIcons/unknownFlag.svg"
                      }
                      alt={item}
                      className={
                        item === "Unknown" ? "unknownFlag" : "country-flag"
                      }
                      style={{
                        width: "20px",
                        height: "15px",
                        marginRight: "8px",
                        verticalAlign: "middle",
                      }}
                    />
                  )}

                  {config.isRisk ? (
                    <div
                      className={renderRiskFilterClassName(item.toLowerCase())}
                    >
                      {item}
                    </div>
                  ) : (
                    item
                  )}
                </div>
              </label>
            </div>
          );
        })}

        {filteredList.length === 0 && (
          <div className="no-results">No results found.</div>
        )}
      </div>

      <div className="sticky-footer">
        <button className="cancel" onClick={handleCancel}>
          Cancel
        </button>
        <button className="cancel" onClick={onClear}>
          Clear
        </button>
        <button className="apply" onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
}
